<template>
  <article :id="uid" @click="pageLink('/' + uid)" class="page text-indent" :class="$route.path === '/' + uid  ?  'active mobile-active' : ''">
	 	<transition appear
		 	v-on:before-enter="beforeEnter"
	    v-on:enter="enter"
		  v-on:after-enter="afterEnter"
	    v-bind:css="false">
  	<section>
  		<header class="text-mono">
  			<h2><span>0{{ index }}. {{ title }}</span></h2>
  		</header>
  	  <main :class="['main', uid]">
  	    <section class="page-content">
  		    <prismic-rich-text :field="content"/>
  		    
  		    	<template v-if="uid == 'about'">
              <span class="text-mono"><a href="https://special-offer.studio" target="_blank">Site by Special—Offer</a></span>
  		     <div class="page-currently mobile">
	          <template v-for="(item,index) in current">
			        <div>
		            <div class='text-mono'>{{ item.current_title }}</div>
			          <div class="text"><prismic-rich-text :field="item.current_text" /></div>
							  <div class="image"><prismic-image :field="item.current_thumbnail" /></div>
			        </div>
	          </template>
	        </div>
  		    	</template>
  		    
  		    <template v-if="clients.length > 1">
  		    <Client v-for="(item, index) in clients" :key="item.id" :client="item"/>
  		    </template>
  	    </section>
  	  </main>
  	</section>
	 	</transition>
  </article>
</template>

<script>
import prismicDOM from 'prismic-dom'
import Velocity from 'velocity-animate'
import Client from './Client.vue'

export default {
  name: 'Page',
  props: ['index', 'page_id'],
  data () {
    return {
	    uid: null,
      title: null,
      content: null,
      current: [],
      clients: []
    }
  },
  components: {
    Client
  },
  computed: {
    active: function () {
      return this.firstName + ' ' + this.lastName
    }
  },
  methods: {
	  beforeEnter: function (el) {
      el.style.opacity = 0
    },
    enter: function (el, done) {
	    Velocity(el, { scaleX: '-1' }, { duration: this.$props.index*100 + 500 })
      Velocity(el, { opacity: 1 }, { duration: this.$props.index*100 })
      Velocity(el, { scaleX: '1' }, { duration: this.$props.index*100 })
    },
    afterEnter: function (el) {
    },
 	  pageLink (route) {
/*
	 	  var el = "#" + this.uid;
	 	  var scrollTo = $(el).offset().top;
*/
		  this.$router.push(route)
/*
		  this.$nextTick(function () {
        $("html, body").animate({ scrollTop: scrollTo  });
      })
*/
	  },
	  scroller (uid) {
		  var el = "#" + uid;
		  console.log(el);
	 	  var scrollTo = $(el).offset().top;
	    $("html, body").animate({ scrollTop: scrollTo  });
		},
	  getContent (uid) {
      this.$prismic.client.getByUID('page', uid)
        .then((document) => {
          if (document) {
            this.uid = document.uid
            this.title = document.data.title
	          this.content = document.data.content
	          this.clients = document.data.clients
          }
        })
    },
    getCurrent () {
		  this.$prismic.client.getSingle('site')
		  	.then((document) => {
			  	this.current = document.data.current;
		  	})
	  }
  },
  created () {
	  this.getContent(this.$props.page_id.uid);
	  this.getCurrent();
  },
  mounted() {

//        setTimeout(function() {
//          $('#about').addClass('loaded flipped');
//        }, 500);

//        setTimeout(function() {
//          $('#the-community').addClass('loaded flipped');
//          $('#about').removeClass('flipped');

//        }, 750);

//        setTimeout(function() {
//          $('#the-community').removeClass('flipped');
//          $('#clients').addClass('loaded flipped');
//        }, 1000);

//        setTimeout(function() {
//          $('#clients').removeClass('flipped');
//        }, 1250);
  }
}
</script>

<style scoped>
	

</style>